import { useI18n } from '@/i18n'
import { Badge } from './Badge'

export function RequiredBadge(props: { announced?: boolean }) {
  const { t } = useI18n()

  return (
    <Badge
      variant="primary"
      size="sm"
      class="ml-2 align-middle"
      data-brand-badge
      aria-hidden={props.announced === false ? 'true' : undefined}
    >
      {t('common.required')}
    </Badge>
  )
}
